import {
  START_LOADING_SUPPLIER_CONTACTS,
  SUPPLIER_CONTACTS_LOAD_SUCCESS,
  SUPPLIER_CONTACTS_LOAD_FAILED,
  SUPPLIER_CONTACT_CREATE_SUCCESS,
  SUPPLIER_CONTACT_UPDATE_SUCCESS,
  SUPPLIER_CONTACT_DELETE_SUCCESS,
} from '../actions/types';

const initialState = {
  loadingSupplierContacts: false,
  supplierContacts: []
};

const supplierContactReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case START_LOADING_SUPPLIER_CONTACTS:
      return {
        ...state,
        loadingSupplierContacts: true
      };
    case SUPPLIER_CONTACTS_LOAD_SUCCESS:
      return {
        ...state,
        loadingSupplierContacts: false,
        supplierContacts: Array.isArray(payload.data) ? payload.data : []
      };
    case SUPPLIER_CONTACTS_LOAD_FAILED:
      return {
        ...state,
        loadingSupplierContacts: false
      };
    case SUPPLIER_CONTACT_CREATE_SUCCESS:
      return {
        ...state,
        supplierContacts: payload && payload._id ? [...state.supplierContacts, payload] : state.supplierContacts
      };
    case SUPPLIER_CONTACT_UPDATE_SUCCESS:
      return {
        ...state,
        supplierContacts: state.supplierContacts.map(v => {
          if (v._id === payload._id) {
            return payload;
          }
          return v;
        })
      };
    case SUPPLIER_CONTACT_DELETE_SUCCESS:
      return {
        ...state,
        supplierContacts: state.supplierContacts.filter(v => v._id !== payload)
      };
    default:
      return state;
  }
};

export default supplierContactReducer;
